module.exports = __webpack_public_path__ + "static/media/educationPicture.8cfa5edf.png";